import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/shared/components/shadcn/Avatar";
import { getInitials } from "@/shared/utils/getInitials";
import { getColorForInitials } from "@/shared/utils/getColorForInitials";
import { cn } from "@/shared/utils/cn";
import { useCurrentProfile } from "../hooks/useCurrentProfile";

interface UserAvatarProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

const sizeClasses = {
  sm: "h-8 w-8",
  md: "h-10 w-10",
  lg: "h-12 w-12",
  xl: "h-24 w-24",
};

export function UserAvatar({ className, size = "md" }: UserAvatarProps) {
  const { profile } = useCurrentProfile();

  const imageUrl = profile?.profileImageSrc || undefined;
  const displayName = profile?.displayName || profile?.firstName || "User";
  const [displayFirstName = "", ...displayLastName] = displayName.trim().split(/\s+/);
  const initials = getInitials(
    profile?.firstName || displayFirstName,
    profile?.lastName || displayLastName.join(" ")
  );

  return (
    <Avatar className={`${sizeClasses[size]} ${className || ""}`}>
      <AvatarImage src={imageUrl} alt={displayName} />
      <AvatarFallback className={cn("font-semibold text-primary-foreground", getColorForInitials(initials))}>{initials}</AvatarFallback>
    </Avatar>
  );
}
